import { Box, Grid, Skeleton } from '@mui/material';

interface SearchFiltersSkeletonProps {
  disableFilters?: boolean;
  disableSearch?: boolean;
  isTitleVisible?: boolean;
}
export const SearchFiltersSkeleton: React.FC<SearchFiltersSkeletonProps> = ({
  disableFilters = false,
  disableSearch = false,
  isTitleVisible = true,
}) => {
  return (
    <Box sx={{ py: 3, bgcolor: 'grey.50' }} className="container-fluid">
      {isTitleVisible && <Skeleton variant="rectangular" height="1.5rem" width="15rem" sx={{ mb: 2 }} />}
      <Grid container spacing={1.5}>
        {!disableSearch && (
          <>
            <Grid item xs={12} sm>
              <Skeleton height="3rem" width="100%" variant="rectangular" />
            </Grid>
            <Grid item>
              <Skeleton height="3rem" width="7.5rem" variant="rectangular" />
            </Grid>
          </>
        )}
        {!disableFilters && (
          <Grid item>
            <Skeleton height="3rem" width="7.5rem" variant="rectangular" />
          </Grid>
        )}
      </Grid>
    </Box>
  );
};
